"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import AvatarComponent from "@/components/layout/components/AvatarComponent.vue";
import ChangeTeamItem from "@/components/ChangeTeamItem.vue";
import API from "@ym-framework/api-utils";
import { DashboardClientModel } from "@/models/DashboardClient.model";
import { UiConfirm } from "@/service/ConfirmBox/confirm";
import UiDialog from "@/components/dialog/UiDialog.vue";
import { Debounce } from "vue-debounce-decorator";
const kefuWechatQrcodeUrl = require("../../assets/img/wechat_qrcode.png");
const kefuWechatUrl = require("../../assets/img/kefu_wechat.png");
const kefuQQUrl = require("../../assets/img/kefu_qq.png");
const kefu400Url = require("../../assets/img/kefu_400.png");
const chatGpt = require("../../assets/dragpage/top_chat_gpt.jpg");
const rpaPng = require("../../assets/dragpage/280-40.jpg");
const ttsPng = require("../../assets/dragpage/tts_ads.png");
const applets = require("../../assets/img/applets.png");
const contact_us = require("../../assets/img/contact_us.png");
const feedback = require("../../assets/img/feedback.png");
const presents = require("../../assets/img/presents.png");
const videoClass = require("../../assets/img/videos.png");
const advPng = require("../../assets/dragpage/adv_280_40.jpg");
const qr_code = require("../../assets/img/download_android.png");
import { WebsocketViewService } from "@/utils/webSocketViewService";
import ProgressComponent from "../progress/Progress.vue";
import BrowserProgressComponent from "../progress/BrowserProgress.vue";
import DownloadTipDialog from "@/app_views/homePage/DownloadTipDialog.vue";
import NoticeDialog from "./components/dialog/NoticeDialog.vue";
import UpdateDialog from "./components/dialog/UpdateDialog.vue";
import BlockDialog from "./components/dialog/BlockDialog.vue";
import DiskRoomDialog from "./components/dialog/DiskRoomDialog.vue";
import OverFlowDialog from "./components/dialog/OverFlowDialog.vue";
import DateFormat from "@/framework/timeformatter";
const vipIcon = require("../../assets/midsafety/yundun.png");
let LayoutHeader = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    //实例化webSocket服务
    this.webSocketService = WebsocketViewService;
    //客户端信息
    this.main_info = new DashboardClientModel();
    //客户端更新提示弹窗
    this.updatenotify = null;
    //浏览器核心下载进度条提示弹窗
    this.browsernotifys = [];
    //等待打开的店铺
    this.waitingOpenShops = [];
    //热更新提示弹窗
    this.hot_notify = null;
    //客户端更新数据
    this.update_datas = null;
    //废参数
    this.changeteam = false;
    //废参数
    this.changeteamnew = false;
    //展示锁。为了防止更新提示弹出过多
    this.showLock = false;
    //更新信息锁，为了防止更新内容信息弹出多个
    this.showUpdate = false;
    //客服微信图片地址
    this.kefuWechatUrl = kefuWechatUrl;
    //客服微信二维码图片地址
    this.kefuWechatQrcodeUrl = kefuWechatQrcodeUrl;
    //实例化图片地址
    this.kefuQQUrl = kefuQQUrl;
    //传递客服电话图片地址
    this.kefu400Url = kefu400Url;
    //横版广告图片
    this.KV_PNG = chatGpt;
    // TTS广告图片
    this.TTS_PNG = ttsPng;
    //TK广告图片
    // TK_PNG: any = tiktok;
    // RPA广告图片
    // RPA_PNG: any = rpaPng;
    // 双十一
    this.ADV_PNG = advPng;
    //微信小程序
    this.applets = applets;
    //联系我们图片
    this.contact_us = contact_us;
    //意见反馈图片
    this.feedback = feedback;
    //邀请有礼图片
    this.presents = presents;
    //视频课堂
    this.videoClass = videoClass;
    //下载二维码图片地址
    this.qr_code = qr_code;
    //下载提示信息
    this.downloadTip = "";
    //下载地址信息
    this.downloadUrl = "";
    //下载版本信息
    this.downloadVersion = "";
    //当前版本信息
    this.version = "";
    // vip图标
    this.vip_icon = vipIcon;
    // 同时下载的浏览器核心和版本
    this.downloadingBrowser = [];
    // 是否显示广告
    this.showADFlag = false;
  }
  // @Ref("ai_helper_dialog")
  // public _ai_helper_dialog!: AIHelperDialog;
  // @Ref("ai_help_drawer")
  // public _ai_help_drawer!: AIHelpDrawer;
  mounted() {
    return __async(this, null, function* () {
      this.webSocketService._ipcEvent.on(
        "event:user.force.logout",
        (data) => __async(this, null, function* () {
          if (data.code === "USER_ABNORMAL_LOGIN") {
            yield this.offLineTip();
          } else if (data.code === "FORCE_LOGOUT") {
            yield this.offLineDeleteTip();
          } else {
            yield this.offLineTip();
          }
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:user.force.closeShop",
        (data) => __async(this, null, function* () {
          location.reload();
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:device.abnormal.offline",
        (data) => __async(this, null, function* () {
          yield this.checkUserDevice();
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:user.local.ip.test",
        (data) => __async(this, null, function* () {
          yield this.checkUserIP();
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:service.push.message",
        (data) => __async(this, null, function* () {
          if (data.value.value.target === "user.offline") {
            yield this.offLineTip();
          }
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:pageEvent.changeTeam.success",
        (data) => __async(this, null, function* () {
          yield this.ChangeTeamMsg();
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:pageEvent.logout.refresh",
        (data) => __async(this, null, function* () {
          location.reload();
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:update.auto.download",
        (data) => __async(this, null, function* () {
          this.updateStart();
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:update.need.download",
        (data) => __async(this, null, function* () {
          yield this.handleUpdate(data);
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:update.need.install",
        (data) => __async(this, null, function* () {
          try {
            let updateResponse = yield API.get(
              `api://base.update.auth/v1/client/updates/check_by_account`,
              {
                params: {
                  clientVersion: this.version,
                  account: this.$session.account
                }
              }
            );
            if (updateResponse.data.canUpdate) {
              this.startInstall();
            } else {
              this.installStart();
            }
          } catch (error) {
            this.installStart();
          }
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:pageEvent.start.install",
        (data) => __async(this, null, function* () {
          this.updateStart();
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:pageEvent.close.notification",
        (data) => __async(this, null, function* () {
          this.closeNotify();
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:virtualbrowser.download.start",
        (data) => __async(this, null, function* () {
          if (data.value.browser_core) {
            let browserVersion = `${data.value.browser_core}_${data.value.browser_version}`;
            if (this.downloadingBrowser.includes(browserVersion)) {
              let item2 = {
                shop_id: data.value.shop_id,
                new_shop_id: data.value.new_shop_id,
                vd_id: data.value.vd_id,
                new_vd: data.value.new_vd,
                launcher_value: data.value.launcher_value,
                browser_core: data.value.browser_core,
                browser_version: data.value.browser_version
              };
              this.waitingOpenShops.push(item2);
              return;
            }
            this.downloadingBrowser.push(browserVersion);
            try {
              yield API.get(
                `api://base.local/storages/session/browserDownload_${data.value.browser_core}_${data.value.browser_version}`,
                {
                  method: "GET"
                }
              );
              this.browsernotifys.push(
                this.$notify({
                  title: this.$t("homepage.browser_core_unzipping"),
                  message: this.$t(
                    "homepage.browser_core_unzipping_message"
                  )
                })
              );
            } catch (error) {
              const h = this.$createElement;
              this.browsernotifys.push(
                this.$notify({
                  title: `${data.value.browser_core}${data.value.browser_version}${this.$t("homepage.browser.downloading")}`,
                  dangerouslyUseHTMLString: true,
                  duration: 0,
                  message: h(BrowserProgressComponent)
                })
              );
              yield API.put(
                `api://base.local/storages/session/browserDownload_${data.value.browser_core}_${data.value.browser_version}`,
                {
                  message: "no.show.browser.download",
                  model: "no.show.browser.download"
                }
              );
            }
            let item = {
              shop_id: data.value.shop_id,
              new_shop_id: data.value.new_shop_id,
              vd_id: data.value.vd_id,
              new_vd: data.value.new_vd,
              launcher_value: data.value.launcher_value,
              browser_core: data.value.browser_core,
              browser_version: data.value.browser_version
            };
            this.waitingOpenShops.push(item);
          } else {
            if (this.browsernotifys.length > 0) {
              let item2 = {
                shop_id: data.value.shop_id,
                new_shop_id: data.value.new_shop_id,
                vd_id: data.value.vd_id,
                new_vd: data.value.new_vd,
                launcher_value: data.value.launcher_value
              };
              this.waitingOpenShops.push(item2);
              return;
            }
            const h = this.$createElement;
            this.browsernotifys.push(
              this.$notify({
                title: this.$t("homepage.browser.downloading"),
                dangerouslyUseHTMLString: true,
                duration: 0,
                message: h(BrowserProgressComponent)
              })
            );
            let item = {
              shop_id: data.value.shop_id,
              new_shop_id: data.value.new_shop_id,
              vd_id: data.value.vd_id,
              new_vd: data.value.new_vd,
              launcher_value: data.value.launcher_value
            };
            this.waitingOpenShops.push(item);
          }
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:dynamicBrowser.download.complete",
        (data) => __async(this, null, function* () {
          if (this.browsernotifys.length > 0) {
            const notify = this.browsernotifys[0];
            notify.close();
            this.browsernotifys.splice(0, 1);
          }
          const browserVersion = `${data.data.brand}_${data.data.version}`;
          if (this.downloadingBrowser.includes(browserVersion)) {
            this.downloadingBrowser = this.downloadingBrowser.filter(
              (item) => item !== browserVersion
            );
          }
          setTimeout(() => __async(this, null, function* () {
            if (this.downloadingBrowser.length === 0) {
              for (const item of this.waitingOpenShops) {
                let flag = true;
                try {
                  yield API.get(
                    `api://base.local/storages/preference/mainExtensionVersion`
                  );
                  flag = true;
                } catch (error) {
                  flag = false;
                }
                if (flag) {
                  yield API.post(`api://base.local/websockets/main`, {
                    model: "virtualBrowser.launcher_new",
                    value: {
                      shop_id: item.shop_id,
                      new_shop_id: item.new_shop_id,
                      vd_id: item.vd_id,
                      new_vd: item.new_vd,
                      launcher_value: item.launcher_value
                    }
                  });
                  yield API.post(`api://base.local/websockets/view`, {
                    model: "virtualbrowser.launcher.restart",
                    value: {
                      vd_guid: item.vd_id,
                      new_vd: item.new_vd,
                      shop_id: item.shop_id,
                      new_shop_id: item.new_shop_id
                    }
                  });
                  this.waitingOpenShops = this.waitingOpenShops.filter(
                    (item2) => item2.shop_id !== item2.shop_id
                  );
                } else {
                  yield API.post(`api://base.local/websockets/main`, {
                    model: "virtualBrowser.launcher",
                    value: {
                      shop_id: item.shop_id,
                      new_shop_id: item.new_shop_id,
                      vd_id: item.vd_id,
                      new_vd: item.new_vd,
                      launcher_value: item.launcher_value
                    }
                  });
                  yield API.post(`api://base.local/websockets/view`, {
                    model: "virtualbrowser.launcher.restart",
                    value: {
                      vd_guid: item.vd_id,
                      new_vd: item.new_vd,
                      shop_id: item.shop_id,
                      new_shop_id: item.new_shop_id
                    }
                  });
                  this.waitingOpenShops = this.waitingOpenShops.filter(
                    (item2) => item2.shop_id !== item2.shop_id
                  );
                }
                if (this.waitingOpenShops.length === 0) {
                  this.waitingOpenShops = [];
                }
              }
            }
          }), 2e3);
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:dynamicBrowser.download.failed",
        (data) => __async(this, null, function* () {
          if (this.browsernotifys.length > 0) {
            for (const notify of this.browsernotifys) {
              notify.close();
            }
            this.browsernotifys = [];
          }
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:user.power.change",
        (data) => __async(this, null, function* () {
          yield this.changePowerNotice();
        })
      );
      this.webSocketService._ipcEvent.on(
        "event:clientEvent.update.download.complete",
        (data) => __async(this, null, function* () {
          try {
            let updateResponse = yield API.get(
              `api://base.update.auth/v1/client/updates/check_by_account`,
              {
                params: {
                  clientVersion: this.version,
                  account: this.$session.account
                }
              }
            );
            if (updateResponse.data.canUpdate) {
              this.startInstall();
            }
          } catch (error) {
          }
        })
      );
      this.hot_notify = null;
      try {
        let response = yield API.get(`api://base.local/system/locale`);
        if (response.data.locale === "zh-CN" || response.data.locale === "en-US" || response.data.locale === "es-ES") {
          this.$i18n.locale = response.data.locale;
          document.documentElement.lang = response.data.locale;
          localStorage.setItem("lang", response.data.locale);
        } else {
          this.$i18n.locale = "zh-CN";
          document.documentElement.lang = "zh-CN";
          localStorage.setItem("lang", "zh-CN");
        }
      } catch (error) {
        this.$i18n.locale = "zh-CN";
        document.documentElement.lang = "zh-CN";
        localStorage.setItem("lang", "zh-CN");
      }
      yield this.getVersion();
      yield this.checkUpdate();
      yield this.checkAutoClean();
      yield this.getMainInfo();
      yield this.checkDiskRoom();
      yield this.checkOverFlow();
    });
  }
  // async checkShowAD(){
  //   try{
  //     this.showADFlag = await this.showAD();
  //   }catch(error:any){
  //   }
  // }
  // 启动客户端期间只调用一次
  // async showAD(){
  //   try{
  //       // 获取服务器时间，计算当前时间是否在某一个区间
  //       let timeResponse = await API.get(`api://base/api/v8/current-time`)
  //       let dateNow = timeResponse.data.time;
  //       // 计算当前时间dateNow是否在11月4日上午10点到11月11日24点
  //       let dateStart = new Date("2025-11-04 10:00:00").getTime();
  //       let dateEnd = new Date("2025-11-11 23:59:59").getTime();
  //       if(dateNow >= dateStart && dateNow <= dateEnd){
  //         // 在区间内
  //         return true;
  //       }else{
  //         return false;
  //       }
  //   }catch(error:any){
  //     return false;
  //   }
  // }
  // 指定用户检测强制更新
  handleUpdate(data) {
    return __async(this, null, function* () {
      try {
        let updateResponse = yield API.get(
          `api://base.update.auth/v1/client/updates/check_by_account`,
          {
            params: {
              clientVersion: this.version,
              account: this.$session.account
            }
          }
        );
        if (updateResponse.data.canUpdate) {
          yield API.post(`api://base.local/update/tasks`, {
            url: data.url
          });
          this.updateStart(true);
        } else {
          if (!sessionStorage.getItem("updata_message_notify")) {
            this.downloadTip = data.tip;
            this.downloadUrl = data.url;
            this.downloadVersion = data.last;
            this._download_tip_dialog.open();
          }
        }
      } catch (error) {
        console.log(error);
        if (!sessionStorage.getItem("updata_message_notify")) {
          this.downloadTip = data.tip;
          this.downloadUrl = data.url;
          this.downloadVersion = data.last;
          this._download_tip_dialog.open();
        }
      }
    });
  }
  // 检测流量超限
  checkOverFlow() {
    return __async(this, null, function* () {
      try {
        try {
          const response = yield API.get(
            `api://base.local/storages/preference/flow_overrange`
          );
          const date = response.data.value.date;
          const now = new Date().getTime();
          if (now - date > 1e3 * 60 * 60 * 24) {
            let response2 = yield API.get(
              `api://base.auth.pro/v1/virtual-desktops/flow_overranges`
            );
            if (response2.data.datas.length > 0) {
              this._over_flow_dialog.open(response2.data.datas);
            }
          }
          return;
        } catch (error) {
          let response = yield API.get(
            `api://base.auth.pro/v1/virtual-desktops/flow_overranges`
          );
          if (response.data.datas.length > 0) {
            this._over_flow_dialog.open(response.data.datas);
          }
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  // // 展开AI助手抽屉
  // async showAIHelperDrawer(){
  //   try{
  //     this._ai_help_drawer.openDrawer();
  //   }catch(error:any){
  //     console.log(error);
  //   }
  // }
  // // 展开AI助手按钮
  // async showAIHelperButton(){
  //   try{
  //     this._ai_helper_dialog.showButton();
  //   }catch(error:any){
  //     console.log(error);
  //   }
  // }
  // 跳转流量消耗详情
  toFlow() {
    this.$router.push("/cost_management#FlowDetail");
  }
  // 权限变更通知
  changePowerNotice() {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(
          this.$t("user.power_change_content"),
          this.$t("vdbindshop.binding_shop_confirm_title"),
          {
            roundButton: true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
            showCancelButton: false,
            confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`
          }
        );
      } catch (error) {
        console.log(error);
      }
    });
  }
  // 续费事中监管
  renewVip() {
    this.$router.push("/purchase_service?type=renew");
  }
  // 升级事中监管
  upgradeVip() {
    this.$router.push("/purchase_service");
  }
  // 检测磁盘运行空间 客户端每次启动仅检测一次
  checkDiskRoom() {
    return __async(this, null, function* () {
      try {
        yield API.get(`api://base.local/storages/session/diskCheck`);
      } catch (error) {
        try {
          let response = yield API.get(`api://base.local/system/get-cache-disk`);
          const space = response.data.space;
          const min_space = 50 * 1024 * 1024;
          if (space > min_space) {
            return true;
          } else {
            this._disk_room_dialog.open();
          }
        } catch (error2) {
        } finally {
          yield API.put(`api://base.local/storages/session/diskCheck`, {
            message: "has.check.disk",
            model: "has.check.disk"
          });
        }
      }
    });
  }
  // 更新提示弹窗 同版本或单独给某个版本通知更新的时候可以使用
  updateNotice() {
    return __async(this, null, function* () {
      if (this.version !== "6.8.2") {
        try {
          let response = yield API.get(
            `api://base.local/storages/session/showUpdateNotice`
          );
        } catch (error) {
          this._update_notice.open();
        }
      }
    });
  }
  // 通知弹窗 客户端紧急补救措施 可以弹出任何通知 但需要前端先把内容写好
  openNotice() {
    return __async(this, null, function* () {
      try {
        yield API.get(`api://base.local/storages/preference/login_notice`);
      } catch (error) {
        this._notice_dialog.open();
      }
    });
  }
  // 测试用户本地IP数据并发送数据
  checkUserIP() {
    return __async(this, null, function* () {
      try {
        const net_response = yield API.get(
          `api://base.auth/api/v1/accounts/network_info`
        );
        let sendData = {
          ip: net_response.data.ip,
          ipArea: net_response.data.ipArea,
          isForeign: net_response.data.isForeign
        };
        yield API.post(`api://base.auth/api/v1/client-local-ip`, sendData);
      } catch (error) {
        console.log(error);
      }
    });
  }
  //主动发送请求进行绑定设备
  //下一个版本的客户端 需要把此设备重连的消息chuli加入到message服务中
  checkUserDevice() {
    return __async(this, null, function* () {
      try {
        yield API.post(
          `api://base.local.auth/v2/reverse-proxy/services/messageservice/v1/check/user-devices`
        );
        let response = yield API.get(`api://base.local/v2/dynamic-browsers`);
        let browsers = response.data.data;
        for (const browser of browsers) {
          API.post(`api://base.auth.message/v1/user-shops`, {
            shopId: browser.id,
            vdId: browser.extra.vd_id
          });
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  // 打开视频课堂
  openVideoPage() {
    window.open("https://www.kuajingvs.com/knowledge", "__blank");
  }
  //获取客户端版本信息
  getVersion() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.local/update/version`);
        this.version = response.data.version;
      } catch (error) {
        console.log(error);
      }
    });
  }
  //检测更新消息
  checkUpdate() {
    return __async(this, null, function* () {
      try {
        if (sessionStorage.getItem("send_check_update_message")) {
          return;
        }
        sessionStorage.setItem("send_check_update_message", "yes");
        yield API.post(`api://base.local/websockets/root`, {
          model: "check.update",
          value: {
            message: "check.update"
          }
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  //前往用户设置
  toAccountSetting() {
    if (this.$session.type === "account") {
      this.$router.push("/account_management");
    } else {
      this.$router.push("/account_child");
    }
  }
  //前往消息设置
  toMessageSetting() {
  }
  //前往邀请有礼页面
  toInvitePage() {
    const _url = this.$router.resolve("/cost#InviteMain");
    window.open(_url.href, "__blank");
  }
  //前往意见反馈页面
  toCallbackPage() {
    this.$router.push("/feedback");
  }
  // RPA
  jumptoADV() {
    try {
      window.open(
        "https://mp.weixin.qq.com/s/Vy43AFVQImOLbFW4whhYUA",
        "_blank"
      );
    } catch (error) {
    }
  }
  //kaiwahle
  jumptoKaiWhale() {
    try {
      window.open("https://app.kaiwhale.com/login", "__blank");
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  //passkey
  jumptoPasskey() {
    try {
      window.open("https://www.kuajingvs.com/help2/26348/", "__blank");
    } catch (error) {
      if (error.hasOwnProperty("response")) {
        this.$message.error(error.response.data.errors.datas[0].message);
      }
    }
  }
  //快速购买AI
  // dragJump() {
  //   try {
  //     // if (
  //     //   this.$session!.type === "account" ||
  //     //   this.$session!.permissions.any("VD_NEW")
  //     // ) {
  //     //   this.$router.push({
  //     //     name: "payment",
  //     //     query: { style: "create", rid: "af670588a7ad4e7a81d1706e174a3a5f" },
  //     //   });
  //     // }
  //     // if (
  //     //   this.$session!.type === "user" &&
  //     //   !this.$session!.permissions.any("VD_NEW")
  //     // ) {
  //     //   window.open("https://www.kuajingvs.com/article/23313", "_blank");
  //     // }
  //     window.open("https://www.kuajingvs.com/article/25917","_blank");
  //   } catch (error) {}
  // }
  //更新开始下载
  updateStart(force) {
    if (this.showUpdate === true) {
      return;
    }
    this.showUpdate = true;
    const h = this.$createElement;
    this.updatenotify = this.$notify({
      title: this.$t("homepage.downloading"),
      dangerouslyUseHTMLString: true,
      duration: 0,
      message: h(ProgressComponent, {
        // 在这里传递 props 参数
        props: {
          // 例如：传递一个自定义参数
          // customParam: 'some value',
          isForce: force || false
          // isComplete: false
        }
      })
    });
  }
  //安装包下载完成提示
  installStart() {
    if (this.showLock === true) {
      return;
    }
    this.showLock = true;
    if (sessionStorage.getItem("install_message_notify")) {
      return;
    }
    const h = this.$createElement;
    const notify = this.$notify({
      title: this.$t("homepage.installing"),
      duration: 0,
      message: h("div", {}, [
        h(
          "el-button",
          {
            props: { type: "text" },
            on: {
              click: this.startInstall
            }
          },
          this.$t("homepage.start_install")
        ),
        h(
          "el-button",
          {
            props: { type: "text" },
            style: "color:#c0c4d4",
            on: {
              click: () => {
                this.installNextTime();
                notify.close();
              }
            }
          },
          this.$t("homepage.next_time")
        )
      ])
    });
  }
  //下次再安装
  installNextTime() {
    return __async(this, null, function* () {
      sessionStorage.setItem("install_message_notify", "show");
      yield API.put(`api://base.local/storages/session/updateInstall`, {
        message: "no.need.install",
        model: "no.need.install"
      });
    });
  }
  //开始安装
  startInstall() {
    return __async(this, null, function* () {
      try {
        yield API.post(`api://base.local/update/install`);
      } catch (error) {
        console.log(error);
      }
    });
  }
  //关闭更新提示
  closeNotify() {
    this.updatenotify.close();
    this.updatenotify = null;
  }
  //检测自动清理缓存
  checkAutoClean() {
    return __async(this, null, function* () {
      try {
        const auto_clean_response = yield API.get(
          `api://base.local/storages/preference/autoCleanCache`
        );
        let flag = auto_clean_response.data.value.flag;
        if (!flag) {
          return;
        }
        const auto_setting_response = yield API.get(
          `api://base.local/storages/preference/autoSetting`
        );
        const size = auto_setting_response.data.value.watch_size;
        yield UiConfirm.warnconfirm(
          this.$t("layout.auto_clean_cache_tip_content", {
            size: `${size}MB`
          }),
          this.$t("layout.auto_clean_cache_tip_title"),
          {
            confirmButtonText: this.$t(
              "layout.auto_clean_cache_confirm"
            ),
            cancelButtonText: this.$t("layout.auto_clean_cache_cancel"),
            iconClass: "el-icon-warning"
          }
        );
        const user_data_path_response = yield API.get(
          `api://base.local/storages/preference/userDataPath`
        );
        const _user_data_path = user_data_path_response.data.value.path;
        let user_data_path_info = yield API.get(
          `api://base.local/file-system/paths`,
          {
            params: {
              path: `origin:///${_user_data_path}`
            }
          }
        );
        const user_data_arr = user_data_path_info.data.entry;
        for (const file of user_data_arr) {
          if (file.origin_path.indexOf("kuajingvs_main") !== -1) {
            continue;
          }
          try {
            yield API.delete(`api://base.local/file-system/paths`, {
              params: {
                path: `${file.origin_path}`
              }
            });
          } catch (error) {
            continue;
          }
        }
        this.$message.success(
          this.$t("filesaveconfig.cache_files_cleaned_up")
        );
      } catch (error) {
      }
    });
  }
  ChangeTeamMsg() {
    return __async(this, null, function* () {
      location.reload();
    });
  }
  offLineDeleteTip() {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(
          this.$t("phonelogin.device_offline_tip"),
          this.$t("vdbindshop.binding_shop_confirm_title"),
          {
            roundButton: true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
            showCancelButton: false,
            confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`
          }
        );
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        if (this.$matomo) {
          this.$matomo.resetUserId();
        }
        this.$router.push("/logout");
      } catch (error) {
      }
    });
  }
  offLineTip() {
    return __async(this, null, function* () {
      try {
        yield this.$confirm(
          this.$t("phonelogin.device_offline_tip_content"),
          this.$t("vdbindshop.binding_shop_confirm_title"),
          {
            roundButton: true,
            closeOnClickModal: false,
            closeOnPressEscape: false,
            showClose: false,
            showCancelButton: false,
            confirmButtonText: `${this.$t("vdbindshop.binding_tip_confirm")}`
          }
        );
        yield API.delete(`api://base.local/v2/browsers`);
        yield API.delete(`api://base.local/v2/dynamic-browsers`);
        yield API.delete(`api://base.local/processes`);
        if (this.$matomo) {
          this.$matomo.resetUserId();
        }
        this.$router.push("/logout");
      } catch (error) {
      }
    });
  }
  //前往意见反馈
  toFeedBack() {
    this.$router.push("/feedback");
  }
  //前往联系我们
  toConnectUs() {
    window.open("https://wpa1.qq.com/FzfSmq8R?_type=wpa&qidian=true", "_blank");
  }
  //获取用户信息
  getMainInfo() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth.pro/v1/accounts/dashboard`
        );
        this.main_info = response.data;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //检测用户权限 是否可以展开菜单
  get checkPowers() {
    if (this.$session.type === "account" || this.$session.permissions.is("SHOW_ALL_MENUS")) {
      return true;
    } else {
      return false;
    }
  }
  //下拉框 注销事件
  handleCommand(command) {
    return __async(this, null, function* () {
      switch (command) {
        case "logout":
          try {
            this.toLogout();
          } catch (error) {
            console.dir(error);
          }
          break;
      }
    });
  }
  //用户注销
  toLogout() {
    return __async(this, null, function* () {
      yield UiConfirm.confirm(
        this.$t("headertoolbar.do_you_want_to_log_out"),
        this.$t("headertoolbar.hint"),
        {
          confirmButtonText: this.$t("headertoolbar.confirm"),
          cancelButtonText: this.$t("headertoolbar.cancel")
        }
      );
      try {
        const deviceTokenResponse = yield API.get(
          `api://base.local/storages/session/deviceToken`
        );
        const deviceToken = deviceTokenResponse.data.value.deviceToken;
        yield API.delete(`api://base.auth.message/v1/user-devices`, {
          params: {
            deviceToken
          },
          timeout: 3e3
        });
        yield API.post(`api://base.local/websockets/messageservice`, {
          model: "pageEvent.logout.success",
          value: {
            message: "logout.success"
          }
        });
      } catch (error) {
        console.log("timeout");
      }
      yield API.put(`api://base.auth/api/v1/accounts/logout`);
      yield API.delete(`api://base.local/v2/browsers`);
      yield API.delete(`api://base.local/v2/dynamic-browsers`);
      yield API.delete(`api://base.local/processes`);
      yield API.post("api://base.local/websockets/view", {
        model: "pageEvent.logout.refresh",
        value: {
          message: "logout.refresh.message"
        }
      });
      localStorage.removeItem("shop.page");
      localStorage.removeItem("vd.page");
      if (this.$matomo) {
        this.$matomo.resetUserId();
      }
      this.$router.push("/logout");
    });
  }
  //前往鲸豆充值
  onCharge() {
    try {
      if (this.$route.path !== "/cost_management") {
        this.$router.push("/cost_management");
      } else {
        location.reload();
      }
    } catch (error) {
    }
  }
  //前往主页
  jumptohome() {
    this.$router.push("/");
  }
  //打开邀请弹窗
  openInviteDialog() {
    const _url = this.$router.resolve("/cost#InviteMain");
    window.open(_url.href, "__blank");
  }
  //前往测试团队
  LetChangeTeam(id) {
    return __async(this, null, function* () {
      yield this._change_team_item.changeTeamForTest(id);
    });
  }
  //日期类型转换
  format_date(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.dateformatterDay(DateFormat.check(time));
    }
  }
  //在页面销毁之前注销全部的socket链接侦听器
  beforeDestroy() {
    this.webSocketService._ipcEvent.removeAllListeners();
  }
};
__decorateClass([
  Ref("change-team-item")
], LayoutHeader.prototype, "_change_team_item", 2);
__decorateClass([
  Ref("download_tip_dialog")
], LayoutHeader.prototype, "_download_tip_dialog", 2);
__decorateClass([
  Ref("noticeDialog")
], LayoutHeader.prototype, "_notice_dialog", 2);
__decorateClass([
  Ref("updateDialog")
], LayoutHeader.prototype, "_update_notice", 2);
__decorateClass([
  Ref("blockDialog")
], LayoutHeader.prototype, "_block_dialog", 2);
__decorateClass([
  Ref("diskRoomDialog")
], LayoutHeader.prototype, "_disk_room_dialog", 2);
__decorateClass([
  Ref("overFlowDialog")
], LayoutHeader.prototype, "_over_flow_dialog", 2);
__decorateClass([
  Debounce(800)
], LayoutHeader.prototype, "ChangeTeamMsg", 1);
__decorateClass([
  Debounce(800)
], LayoutHeader.prototype, "offLineDeleteTip", 1);
__decorateClass([
  Debounce(800)
], LayoutHeader.prototype, "offLineTip", 1);
LayoutHeader = __decorateClass([
  Component({
    components: {
      AvatarComponent,
      ChangeTeamItem,
      UiDialog,
      // DragDialog,
      DownloadTipDialog,
      NoticeDialog,
      UpdateDialog,
      BlockDialog,
      DiskRoomDialog,
      OverFlowDialog
      // AIHelperDialog,
      // AIHelpDrawer
    }
  })
], LayoutHeader);
export {
  LayoutHeader as default
};
